// extracted by mini-css-extract-plugin
module.exports = {"container":"privacypolicy_container__dWMVu","upperAlpha":"privacypolicy_upperAlpha__rxjkV"};